import { formatDateNormal } from "@/app/infrastructures/misc/Utils";
import { ShipmentBooking } from "./ShipmentBooking";

export class ListPickupV2ListResponse {
  data = [] as ShipmentBooking[];

  constructor(fields?: Partial<ListPickupV2ListResponse>) {
    Object.assign(this, fields);
  }
}

export class PickupCorporateSummary {
  state = "none";
  sttCount = 0;
  koliCount = 0;
  weightKg = 0;
  contactName = "";
  contactPhone = "";
  addressLine = "";
  nearestScheduleLabel = "";
  specialHandling = [] as string[];
  productTypes = [] as string[];
  defaultAddressId = 0;
  showActivePickupCta = false;
  activePickupCount = 0;
  hasLastPickupHistory = false;
  waitingCourier = 0;
  pickUpPackage = 0;
  pickUpDone = 0;
  agentHub = 0;
  constructor(fields?: Partial<PickupCorporateSummary>) {
    Object.assign(this, fields);
  }
}

export class RequestListPickupDetail {
  isShowDetails = false;

  toQueryString(): string {
    return this.isShowDetails ? "is_show_details=true" : "";
  }

  constructor(fields?: Partial<RequestListPickupDetail>) {
    Object.assign(this, fields);
  }
}

export class ListPickupV2 {
  shipmentId = "";
  clientRef = "";
  clientCode = "";
  pickupSchedule = "";
  transportType = "";
  estimateTotalKoli = 0;
  actualTotalShipment = 0;
  actualTotalKoli = 0;
  pickupType = "";
  serviceCode = "";
  estimateTotalShipment = 0;
  latestStatus = "";
  createdAt = "";
  createdBy = "";
  specialHandling = [] as string[];
  additionalKoli = 0;
  agentHubProcessedStt = 0;
  agentHubProcessedKoli = 0;
  isDhlFirstMilePrintEnabled = false;
  dhlLabelPrintUrl = "";
  constructor(fields?: Partial<ListPickupV2>) {
    Object.assign(this, fields);
  }

  get formatCreatedAt() {
    if (!this.createdAt) {
      return "";
    }
    return [formatDateNormal(this.createdAt, "D MMMM YYYY, HH.mm"), "MYT"]
      .filter(Boolean)
      .join(" ");
  }

  get isDg() {
    return this.specialHandling.includes("dangerous_goods");
  }

  get isQuarantine() {
    return this.specialHandling.includes("quarantine");
  }

  get isWoodPacking() {
    return this.specialHandling.includes("wood_packing");
  }

  get canPrintDhlLabel(): boolean {
    return (
      this.isDhlFirstMilePrintEnabled && Boolean(this.dhlLabelPrintUrl?.trim())
    );
  }
}
